import { Flag, Variant } from '@acies/domain';
import { CheckBoxEvent } from '@acies/ui';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import { AccountFlagsModel } from '../model/account.flags.model';
import { AccountFlagsService } from '../services/account.flags.service';

export class AccountFlagsController {
	#model: AccountFlagsModel;
	#service: AccountFlagsService;
	#translator: TranslateService;
	public constructor(httpClient: HttpClient, model: AccountFlagsModel, sessionStorageService: SessionStorageService, userService: UserService, translator: TranslateService) {
		this.#translator = translator;
		this.#service = new AccountFlagsService(httpClient, sessionStorageService, userService);
		this.#model = model;
		this.#loadVariants(false);
	}

	public enabledChanged(event: Event): void {
		if (event instanceof CheckBoxEvent) {
			if (event.item instanceof Flag) {
				this.#updateVariantEnabled(event.item, event.selected);
			}
		}
	}

	/** When updating the enabled property on a Variant instance, we set a reference to that instance so we can revert later of the service request fails. */
	#updateVariantEnabled(instance: Flag, enabled: boolean) {
		this.#model.updatingFlagInstance = instance;
		const variant = instance.variants.at(0);
		if (variant) {
			this.#model.updatingVariantInstance = variant;
			this.#model.updatingVariantInstance.enabled = enabled;
			const enabledString = this.#translator.currentLang === 'da' ? (enabled ? 'TIL' : 'FRA') : enabled ? 'ON' : 'OFF';
			this.#model.confirmBody = this.#translator.instant(`setup.featureflagsadmin.confirmBody`, { name: instance.name, enabled: enabledString });
			this.#model.showConfirmationDialog();
		}
	}

	public hideConfirmationDialog() {
		if (this.#model.updatingVariantInstance) {
			// revert the enabled property if we cancel in the modal
			this.#model.updatingVariantInstance.enabled = !this.#model.updatingVariantInstance.enabled;
		}
		this.#model.hideConfirmationDialog();
	}

	public confirmationSave() {
		if (this.#model.updatingFlagInstance && this.#model.updatingVariantInstance) {
			this.#updateFlag(this.#model.updatingFlagInstance, this.#model.updatingVariantInstance);
		}
	}

	#updateFlag(flag: Flag, variant: Variant): void {
		this.#model.updatingFlags = true;
		this.#service.updateFlag(flag, variant).subscribe((value) => {
			this.#model.hideConfirmationDialog();
			this.#model.updatingFlags = false;
			if (value instanceof Error) {
				// if we get an error, revert the enabled property that is bound to the UI check-box component,
				// so we get correct UI state that reflects the model.
				variant.enabled = !variant.enabled;
				this.#model.displayErrorDialogFromError(value);
			}
		});
	}

	#loadVariants(refresh = false): void {
		this.#model.services = [];
		this.#service.loadVariants(refresh).subscribe((value) => {
			if (value instanceof Error) {
				this.#model.displayErrorDialogFromError(value);
			} else {
				this.#model.services = value;
			}
		});
	}
}
